import React, {Component} from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import Main from './Main'
import Footer from './Footer'
import Header_Nav from './Header_Nav'


class App extends Component {
  constructor() {
    super()
    this.state = {
      isLoggedIn: false,
      activePage: 'home'
    }

    this.loginHandler = this.loginHandler.bind(this)
    this.pageSelector = this.pageSelector.bind(this)
  }

  loginHandler() {
    this.setState({
      isLoggedIn: !this.state.isLoggedIn
    })
  }

  pageSelector(pageSelected) {
    this.setState({
      activePage: pageSelected
    })
  }

  render() {
    return (
      <div>
        <Header />
        <Header_Nav
          loginHandler={this.loginHandler}
          isLoggedIn={this.state.isLoggedIn}
          pageSelector={this.pageSelector}
          activePage={this.state.activePage}
        />
        {this.state.isLoggedIn && <Sidebar />}
        <Main
          isLoggedIn={this.state.isLoggedIn}
          activePage={this.state.activePage}
        />
      </div>
    )  
  }
}

export default App